import {
    mobileDevicesConstants,
    mobileDevicesFulfilledConstants,
    mobileDevicesPendingConstants,
    mobileDevicesRejectedConstants
} from '../actions';

const initialState = {
    items: [],
    total: 0,
    loading: true,
    error: '',
};

export default function (state = initialState, action) {
    switch (action.type) {
        case mobileDevicesConstants.MOBILE_DEVICES_CLEARED:
            return initialState;
        case mobileDevicesPendingConstants.MOBILE_DEVICES_LOADED:
            return {
                ...state,
                loading: true
            };
        case mobileDevicesFulfilledConstants.MOBILE_DEVICES_LOADED:
            return {
                ...state,
                items: action.payload.mobileDevices,
                total: action.payload.total,
                loading: false
            };
        case mobileDevicesFulfilledConstants.MOBILE_DEVICE_DELETED:
            return state;
        case mobileDevicesFulfilledConstants.MOBILE_DEVICE_ASSIGNED:
        case mobileDevicesFulfilledConstants.MOBILE_DEVICE_CREATED:
        case mobileDevicesFulfilledConstants.MOBILE_DEVICE_UNASSIGNED:
        case mobileDevicesFulfilledConstants.MOBILE_DEVICE_UPDATED:
        case mobileDevicesFulfilledConstants.MOBILE_DEVICE_GROUP_UPDATED:
            return {
                ...state,
                loading: false,
                items: state.items.map(item => (item.id === action.payload.id ? action.payload : item))
            };
        case mobileDevicesFulfilledConstants.MOBILE_DEVICES_GROUPED_UNASSIGNED:
            return {
                ...state,
                items: state.items.map(item => {
                    const newItems = action.payload;
                    for (let i = 0; i < newItems.length; i++) {
                        if (item.id === newItems[i].id) return newItems[i];
                    }
                    return item;
                })
            };
        case mobileDevicesPendingConstants.MOBILE_DEVICE_UPDATED:
        case mobileDevicesPendingConstants.MOBILE_DEVICE_GROUP_UPDATED:
        case mobileDevicesPendingConstants.MOBILE_DEVICE_CREATED:
        case mobileDevicesPendingConstants.MOBILE_DEVICE_ASSIGNED:
            return {
                ...state,
                loading: true,
            };
        case mobileDevicesRejectedConstants.MOBILE_DEVICE_CREATED:
        case mobileDevicesRejectedConstants.MOBILE_DEVICE_UPDATED:
        case mobileDevicesRejectedConstants.MOBILE_DEVICE_GROUP_UPDATED:
        case mobileDevicesRejectedConstants.MOBILE_DEVICE_DELETED:
        case mobileDevicesRejectedConstants.MOBILE_DEVICE_ASSIGNED:
        case mobileDevicesRejectedConstants.MOBILE_DEVICE_UNASSIGNED:
        case mobileDevicesRejectedConstants.MOBILE_DEVICES_GROUPED_UNASSIGNED:
        case mobileDevicesRejectedConstants.MOBILE_DEVICES_LOADED: {
            const error = action.payload;

            if (error.response) {
                return {
                    ...state,
                    loading: false,
                    error: `${error.response.data.errorMessage || error.response.status + ' ' + error.response.statusText}`,
                    ...error.response.data
                };
            } else if (error) {
                return {
                    ...state,
                    loading: false,
                    error: error.message
                };
            }

            return state;
        }
        default:
            return state;
    }
}
